export const ModalName = {
  HarvestModal: "HarvestModal",
  ConfirmModal: "ConfirmModal",
  SendMethModal: "SendMethModal",
  TeenGeneratedModal: "TeenGeneratedModal",
  WrongNetworkModal: "WrongNetworkModal",
  ApeConstructorAnalyzeModal: "ApeConstructorAnalyzeModal",
  LootBoxOpenModal: "LootBoxOpenModal",
  BuyMethModal: "BuyMethModal",
  ApeMintModal: "ApeMintModal",
  LootBoxListModal: "LootBoxListModal",
  ImageModal: "ImageModal",
  ApeRefundModal: "ApeRefundModal"
};
